import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { getPaymentsBillingManagerLocations, useMerchants } from '@frontend/payments-hooks';

export const useCanDoAction = (locationId: string | undefined) => {
  const { hasPayments } = useMerchants(locationId)['firstLocation'];
  const { isPaymentsBillingManager } = getPaymentsBillingManagerLocations({
    locationIds: locationId ? [locationId] : [],
  });

  const canRefund: boolean = hasSchemaACL(locationId ?? '', Permission.PAYMENTS_REFUNDS);
  const canExport: boolean = hasSchemaACL(locationId ?? '', Permission.PAYMENTS_EXPORTS);
  const canModifyWritebacks = isPaymentsBillingManager;
  const allowedPaymentsLocations = isPaymentsBillingManager && hasPayments ? [locationId] : [];

  // TODO: adityaSingh, isPaymentsBillingManager will not be exported from this file
  return { canRefund, canExport, canModifyWritebacks, isPaymentsBillingManager, allowedPaymentsLocations };
};
